import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { TramiteEstado } from '../models/tramite.model';

@Component({
  selector: 'iw-button-download',
  template: '<span class="badge badge-light text-light ml-1" [ngStyle]="colorStatus">Estado: {{ renderValue.nombre }}' +
            '</span>',
  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class StatusTramiteComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // contiene el valor de entrada
  renderValue: TramiteEstado;
  // Contiene el estilo de color del estado
  colorStatus = {};

  ngOnInit() {
    this.renderValue = this.rowData.estado;
    if (this.renderValue.color) {
      this.colorStatus['background-color'] = this.renderValue.color;
    } else {
      this.colorStatus['background-color'] = '#868E96';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/status-tramite.component.ts